import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type { CampaignApiResponse } from '@/features/campaigns/types/campaign';

export type AvailableCoupon = {
  _id?: string;
  id?: string;
  couponCode?: string;
  couponName?: string;
  description?: string;
  discountValue?: number;
  discountType?: 'PERCENTAGE' | 'FLAT' | string;
  minSpend?: number;
};

export type CouponOffer = AvailableCoupon & {
  couponImage?: string;
  maxSpend?: number;
  isActive?: boolean;
  endDate?: string;
};

export type CouponListPagination = {
  totalCount?: number;
  total?: number;
  totalPages?: number;
  pages?: number;
};

export type CouponListResponse = {
  success?: boolean;
  message?: string;
  data?:
    | CouponOffer[]
    | {
        coupons?: CouponOffer[];
        pagination?: CouponListPagination;
      };
  pagination?: CouponListPagination;
};

export async function fetchAvailableCoupons(amount: number) {
  const { data } = await httpClient.post(endpoints.coupons.available, {
    amount,
  });
  return data as CampaignApiResponse<AvailableCoupon[]>;
}

export async function fetchAllCoupons(params: {
  page?: number;
  limit?: number;
}) {
  const { data } = await httpClient.get(endpoints.coupons.all, { params });
  return data as CouponListResponse;
}
